import styled from '@emotion/styled';
import { Modal, theme } from '@ublend-npm/aulaui-next';

type LoaderContainerProps = Readonly<{
  centerOffset: string;
}>;

export const LoaderContainer = styled.div<LoaderContainerProps>`
  position: absolute;
  top: ${({ centerOffset }) => `calc(50% - ${centerOffset})`};
  left: ${({ centerOffset }) => `calc(50% - ${centerOffset})`};
  z-index: 0;
`;

export const ContentContainer = styled.div`
  position: relative;
  height: 100%;
  overflow: scroll;
`;

export const ContentHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.xLarge};
`;

export const ContentHeader = styled.h2`
  margin-top: 0px;
  margin-bottom: 0px;
  font-weight: ${theme.font.weight.medium};
`;

export const HelpLink = styled.div`
  display: flex;
  white-space: pre-wrap;
  margin-bottom: ${theme.spacing.xLarge};

  > a {
    display: inline-flex;
    align-items: end;
    white-space: pre-wrap;
    color: ${theme.color.designSystem.purple80};
  }

  @media (max-width: 762px) {
    display: block;
  }
`;

export const FormErrorBlock = styled.div`
  padding: 64px 96px;
  background-color: ${theme.color.designSystem.background.light.error};
  text-align: center;
  border-radius: ${theme.borderRadius.large};
  position: relative;
  z-index: 1;
`;

export const FormErrorMessage = styled.p`
  padding: ${theme.spacing.medium};
  background-color: ${theme.color.designSystem.background.light.error};
  text-align: left;
  border-radius: ${theme.borderRadius.large};
  font-size: ${theme.font.size.large};
  line-height: 26px;
`;

export const ErrorTitle = styled.p`
  font-weight: ${theme.font.weight.semiBold};
  font-size: 20px;
  line-height: 30px;
  margin-top: 0;
  color: ${theme.color.designSystem.content.light.error};
`;

export const ErrorDescription = styled.p`
  font-size: ${theme.font.size.large};
  line-height: 26px;
  color: ${theme.color.designSystem.content.light.error};
`;

export const StyledModal = styled(Modal)`
  div[class*='itemDefault-Modal'] {
    padding: ${theme.spacing.xLarge};
    border-radius: 16px;
    height: 80%;
    min-width: 50%;
  }
`;

export const IFrame = styled('iframe')`
  z-index: 1;
  position: relative;
  border: none;
  width: 100%;
  height: calc(100% - 112px);

  @media (max-width: 762px) {
    height: calc(100% - 150px);
  }

  @media (max-width: 472px) {
    height: calc(100% - 162px);
  }
`;

export const ScreenReaderOnly = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;
